import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setDrawer, setStage } from 'slices/drawer'
import { STATICS } from 'statics'
import { DRAWER_KEY, DUE_DATE_DRAWER_STAGES, FIREBASE_EVENTS, PLAN_STATUS_KEY } from 'app-constants'
import { useFirebaseEvent } from 'hooks'
import { BaseCard } from '../base-card'

export function DueDateChange() {
  const dispatch = useDispatch()
  const { sendEvent } = useFirebaseEvent()
  const { contractStatus } = useSelector(({ contract: { selected } }) => ({
    contractStatus: selected.contractStatus,
  }))

  function handleClick() {
    dispatch(setDrawer(DRAWER_KEY.DUE_DATE))

    if (contractStatus !== PLAN_STATUS_KEY.ST_CONT_HABILITADO) {
      sendEvent(FIREBASE_EVENTS.CLICK_CHANGE_DUE_DATE_INELIGIBLE)
      dispatch(setStage(DUE_DATE_DRAWER_STAGES.DISABLED))
    } else sendEvent(FIREBASE_EVENTS.CLICK_CHANGE_DUE_DATE)
  }

  return (
    <BaseCard onClick={handleClick} text='Alterar vencimento' icon={<STATICS.CALENDAR_CARD />} />
  )
}
